"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeModPow = void 0;
const nativeModule_1 = require("../nativeModule");
const computeModPow = payload => nativeModule_1.nativeModule.computeModPow(payload);
exports.computeModPow = computeModPow;
